<template>
  <v-app>
    <v-content>
    <v-container>
      <v-row class="mt-2 pt-2">

        <v-col cols="12" sm="6" md="4">
          <v-card>
            <v-img src="img/portada.jpg">
            </v-img>
          </v-card>
        </v-col>
        <v-col class="text-center mx-auto" cols="">

          <v-card elevation="" class="text-center mx-auto">
             <v-card-title  primary-title>
               <h3 >Capitulos</h3>
             </v-card-title>
          <v-list class="text-center overflow-auto" style="height: 310px">
            <v-list-item v-for="e in ep" :key="e.id" :to="'/episodes'+'/'+e.numero">Capitulo {{e.numero}} - {{e.titulo}}</v-list-item>
          </v-list>
          </v-card>

        </v-col>

      </v-row>

      <!-- <vue-disqus shortname="megaloboxlatino"></vue-disqus> -->
      
    </v-container>
    <v-footer class="mx-auto">
      <p class="mx-auto">Megalobox 2019</p>
    </v-footer>
    
      
    </v-content>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      ep: []
    }
  },

  async created() {
    this.ep = await this.$store.dispatch('bindEpisodes')
  }
}
</script>